import { resetDemo } from "@/lib/mockPb";
import { demoRequested, exitDemo } from "@/lib/pocketbase";
import { useIsMobile } from "@/lib/useMediaQuery";

export function DemoBadge() {
  const mobile = useIsMobile();
  // Only offer a way out when the demo was chosen; a demo-only deploy has
  // nowhere to exit to.
  const canExit = demoRequested();
  return (
    <div
      className="no-print"
      style={{
        position: "fixed",
        // Sit above the mobile bottom tab bar; normal corner on desktop.
        // Sits above the tab bar and clear of the + button, via the same token
        // the FAB uses, so the three cannot drift apart again.
        bottom: mobile ? "calc(var(--above-tabbar) + 74px)" : 14,
        right: mobile ? 12 : 14, zIndex: 200,
        display: "flex", alignItems: "center", gap: 10,
        padding: "7px 12px", borderRadius: 8, fontSize: 11.5,
        background: "var(--surface)", border: "1px solid var(--line)",
        color: "var(--ink3)", boxShadow: "0 8px 26px var(--shadow)",
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent)" }} />
      Demo — data saved in this browser only
      <button
        onClick={resetDemo}
        style={linkish}
      >
        Reset
      </button>
      {canExit && (
        <button onClick={exitDemo} style={linkish}>Exit demo</button>
      )}
    </div>
  );
}

const linkish: React.CSSProperties = {
  background: "none", border: "none", color: "var(--accent)", cursor: "pointer",
  fontSize: 11.5, padding: 0, textDecoration: "underline",
};
